var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02158 22.0141C3.55441 22.0141 3.17214 21.6319 3.17214 21.1647L3.172 9.82405C3.172 9.35688 3.55427 8.97461 4.02144 8.97461C4.48861 8.97461 4.87088 9.35688 4.87088 9.82405V21.2073C4.87102 21.6321 4.48876 22.0144 4.02159 22.0144L4.02158 22.0141Z",
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9915 22.0141C19.5243 22.0141 19.142 21.6319 19.142 21.1647V9.82405C19.142 9.35688 19.5243 8.97461 19.9915 8.97461C20.4587 8.97461 20.841 9.35688 20.841 9.82405V21.2073C20.8411 21.6321 20.4588 22.0144 19.9915 22.0144V22.0141Z",
    fill: "#878787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1385 11.1835C20.9686 11.1835 20.7562 11.141 20.6288 11.0135L12.0066 3.96267L3.38447 11.0135C3.04472 11.3109 2.49251 11.2684 2.19514 10.8861C1.89777 10.5464 1.94029 9.99416 2.32256 9.69679L11.497 2.22141C11.7944 1.96656 12.2616 1.96656 12.5589 2.22141L21.6908 9.69679C22.0305 9.99416 22.1156 10.5039 21.8182 10.8861C21.6483 11.0984 21.3934 11.1835 21.1386 11.1835H21.1385Z",
    fill: "#878787"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.393 22.0143H8.22676C7.75959 22.0143 7.37732 21.6321 7.37732 21.1649C7.37732 20.6977 7.75959 20.3154 8.22676 20.3154H10.393C10.8601 20.3154 11.2424 20.6977 11.2424 21.1649C11.2424 21.6321 10.8601 22.0143 10.393 22.0143Z",
    fill: "#878787"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.393 18.4889H8.22676C7.75959 18.4889 7.37732 18.1066 7.37732 17.6395C7.37732 17.1723 7.75959 16.79 8.22676 16.79H10.393C10.8601 16.79 11.2424 17.1723 11.2424 17.6395C11.2424 18.1492 10.8601 18.4889 10.393 18.4889Z",
    fill: "#878787"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7867 22.0143H13.6204C13.1533 22.0143 12.771 21.6321 12.771 21.1649C12.771 20.6977 13.1533 20.3154 13.6204 20.3154H15.7867C16.2538 20.3154 16.6361 20.6977 16.6361 21.1649C16.6362 21.6321 16.254 22.0143 15.7867 22.0143Z",
    fill: "#878787"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7867 18.4889H13.6204C13.1533 18.4889 12.771 18.1066 12.771 17.6395C12.771 17.1723 13.1533 16.79 13.6204 16.79H15.7867C16.2538 16.79 16.6361 17.1723 16.6361 17.6395C16.6362 18.1492 16.254 18.4889 15.7867 18.4889Z",
    fill: "#878787"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1107 15.3883H10.9445C10.4774 15.3883 10.0951 15.0061 10.0951 14.5389C10.0951 14.0717 10.4774 13.6895 10.9445 13.6895H13.1107C13.5779 13.6895 13.9602 14.0717 13.9602 14.5389C13.9603 15.0061 13.5355 15.3883 13.1107 15.3883Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/Inventory.f82906fd984b7e6fb03e225b4958867f.svg";
export { ForwardRef as ReactComponent };